<script src="../app.routing.ts"></script>

<div class="" [class.hidden]="preLoader"
    style="width: 100%;text-align: center;height: 100%;position: fixed;padding-top: 40vh;z-index: 9999;background: rgba(255, 255, 255, 0.94);">
    <img class="animated infinite pulse" src="images_ext/logo1.png" style="width: 125px;">
</div>

<div class="menubar-hoverable header-fixed menubar-pin "
    style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
    <!-- header -->
    <!--  -->


    <!-- BEGIN BASE-->
    <div id="base">
        <div class="hide" id="load_new_admissions"></div>
        <!-- BEGIN OFFCANVAS LEFT -->
        <div class="offcanvas">
        </div>
        <!--end .offcanvas-->
        <!-- END OFFCANVAS LEFT -->

        <!-- BEGIN CONTENT-->
        <div id="content">
            <section>
                <div class="section-body">


                    <div class="whole-box3">

                        <div class="col-md-12 content-div">
                            <div class="col-md-12 school-heading-div">
                                <span class="school-name">Settings</span>
                                <!-- <div class="logout-button">Logout</div> -->
                            </div>

                            <div class="col-md-12 feature-setting-header">
                                <div class="col-md-2 feature-title">
                                    School Features
                                </div>
                                <div class="col-md-4 feature-option">
                                    <select class="feature-list" (change)="getFeatureList($event.target.value)">
                                        <option disabled>Select School</option>
                                        <option value="{{school.schoolId}}" *ngFor="let school of getSchoolListArray" class="{{school.isSuspended == 1 ? 'suspended-option' : ''}}">
                                            {{school.schoolName}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6 feature-search">
                                    <input (keyup)="searchFeature($event.target.value)"
                                        class="feature-search-box" type="text"
                                        placeholder="&#61442;   Search Feature">
                                </div>
                            </div>

                            <div class="col-md-12 feature-setting-table">
                                <div  *ngIf="bluewingsftrelst.length == 0" class="col-md-12" style="text-align: center;background: url('../../assets/img/noresult.jpg');background-size: contain;background-position: -10px 4px;color: #909090;">
                                    <div class="col-md-12" style="min-height: 300px;padding-top: 4em;">
                                      <h1 style="font-size: 4em;"><i class="fa fa-gears"></i></h1>
                                      <h3>No Results</h3>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table id="fearture-table" class="display nowrap" cellspacing="0" width="100%">
                                        <thead class="table-head">
                                            <tr>
                                                <th class="table-heading" style="width: 35%;">Feature Name</th>
                                                <th class="table-heading" style="width: 40%;">Description</th>
                                                <th class="table-heading" style="width: 25%;">Manage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="no-data" style="display: none;">No Data Matching</tr>
                                            <tr class="gradeX" *ngFor="let flist of bluewingsftrelst">
                                                <th class="table-data">{{flist.BluewingsFeatureName}}</th>
                                                <th class="table-data">{{flist.BluewingsFeatureDescription}}</th>
                                                <th class="table-data">
                                                    <div class="btn-group" data-toggle="buttons" 
                                                    [style.display]="flist.FeatureEditableStatus == 'EDITABLE' ? '':'none'">
                                                        <label (click)="updateFeatureList(flist.pkSchoolFeatureId,'ENABLED')"
                                                            style="font-size: 10px;"
                                                            class="btn ink-reaction action-btn"
                                                            [ngClass]="flist.ActiveStatus == 'ENABLED' ? 'active' : ''">
                                                            <input type="radio" name="options">
                                                            <i class="fa fa fa-check-circle"></i> Enable
                                                        </label>

                                                        <label (click)="updateFeatureList(flist.pkSchoolFeatureId,'DISABLED')"
                                                            style="font-size: 10px;"
                                                            class="btn ink-reaction action-btn"
                                                            [ngClass]="flist.ActiveStatus == 'DISABLED' ? 'active' : ''">
                                                            <input type="radio" name="options">
                                                            <i class="fa fa-minus-circle"></i> Disable
                                                        </label>
                                                    </div>
                                                    <div
                                                        [style.display]="flist.FeatureEditableStatus != 'EDITABLE' ? '':'none'">
                                                        <h5>NOT EDITABLE</h5>
                                                    </div>
                                                </th>
                                            </tr>
                                            
                                            <!-- <tr class="gradeX">
                                                <th class="table-data">test1</th>
                                                <th class="table-data">sdfghjkl asdcfvgbhjk dtfgbhj</th>
                                                <th class="table-data">
                                                    <button class="enable-btn"><i class="fa fa-check-circle"></i>
                                                        Enable</button>
                                                    <button class="disable-btn"><i class="fa fa-minus-circle"></i>
                                                        Disable</button>
                                                </th>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>



                        </div>

                    </div>


                </div>
            </section>
        </div>
        <!--end #content-->
        <!-- END CONTENT -->

        <!-- Menubar -->
        <!--  -->

    </div>
    <!--end #base-->
    <!-- END BASE -->
</div>